import { render, staticRenderFns } from "./term_of_use.vue?vue&type=template&id=cdd864e4&scoped=true&"
import script from "./term_of_use.vue?vue&type=script&lang=js&"
export * from "./term_of_use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd864e4",
  null
  
)

export default component.exports